import moment from "moment";

export const validateMinAge = ({
    date,
    minAge,
    format = "D-M-YYYY",
}: {
    date: string | Date;
    minAge: number;
    format?: string;
}): boolean => {
   // intenta convertir la fecha desde el formato especifico
    const fechaIngresada = moment(date, format, true);

    if (!fechaIngresada.isValid()) {
        throw new Error("La fecha no cumple el formato: " + format);
    }

    const fechaMinima = moment().subtract(minAge, "years");

    return fechaIngresada.isSameOrBefore(fechaMinima);
};
